import { QueryKey } from '@tanstack/react-query';

export const staffQueryKeys = {
  all: () => ['staff'] as const,
  list: (filters: Readonly<{ [k: string]: any }> = {}) =>
    [...staffQueryKeys.all(), { filters }] as QueryKey,
  details: (staffId?: string) => [...staffQueryKeys.all(), staffId] as QueryKey,
  invoice: (invoiceNumber: unknown) => [...staffQueryKeys.all(), invoiceNumber ] as QueryKey,
};
